// IMPORT PACKAGE REFERENCES
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { ProductItem } from './ProductItem';

//COMPONENT

class ProductList extends React.Component {

    render() {
        return (
            <div className='product-wrapper'>
                {this.props.products.length > 0 &&
                    <div className="products">
                        {this.props.products.sort((a, b) => a.name.localeCompare(b.name)).map((product) => {                    
                            return (
                                <ProductItem deleteItem={this.props.deleteItem} id={product.id} key={product.id} product={product} /> 
                            );
                        })}
                    </div>
                }

                {this.props.products.length == 0 &&
                    <div>
                        <div className="empty-list">No Products</div>
                    </div>
                }

            </div>
        );
    }
}

ProductList.propTypes = {
    history: PropTypes.object.isRequired,
    products: PropTypes.array.isRequired,
    deleteItem: PropTypes.func.isRequired,
};

const hoc = withRouter(ProductList);

// EXPORT COMPONENT
export { hoc as ProductList };


// WEBPACK FOOTER //
// ./src/components/pages/Products/ProductList.js